import Emittery from  "emittery";
import axios from "axios";
import DeferredPromise from  "./DeferredPromise"

//Backend singleton
let instance = null;

/**
 * Class representing listeneable events
 */ 
class EventListerners {

    /**
     * @constant
     */
    ON_DEVICE_EVENT = "ON_DEVICE_EVENT";

    /**
     * @constant
     */
    BALANCE_UPDATED = "BALANCE_UPDATED_EVENT";
    
    /**
     * @constant
     */
    SHOW_MESSAGE = "SHOW_MESSAGE_EVENT";

    /**
     * @constant
     */
    BLOCK_UI = "BLOCK_UI_EVENT";
    
    /**
     * @constant
     */
    UNBLOCK_UI = "UNBLOCK_UI_EVENT";
    
    /**
     * @constant
     */
    TERMINAL_STATE_UPDATED = "TERMINAL_STATE_UPDATED_EVENT";
    
    /**
     * @constant
     */
    ALL_TABS_READY = "ALL_TABS_READY_EVENT";
}




//functions called by EGM app to lib
class SubscribableEvents {
    /**
     * @constant
     * 
     */
    ENABLE_KEYPAD_FUNCTIONALITY = "enableKeypadFunctionality";



    /**
     * @constant
     * 
     */
    DEVICE_EVENT = "deviceEvent";

    /**
     * @constant
     */
    UNBLOCK_CONTENT = "sendUnBlockStatus";

    /**
     * @constant
     */
    BLOCK_CONTENT = "sendBlockStatus";
    
    /**
     * @constant
     */
    UPDATE_BALANCE = "sendUpdateBalance";
    
    /**
     * @constant
     */
    BLOCK_TERMINAL = "blockTerminal";
    
    /**
     * @constant
     */
    BLOCK_TERMINAL_AND_CASHOUT = "blockTerminalAndCashout";
    
    /**
     * @constant
     */
    BLOCK_TERMINAL_MESSAGE = "blockTerminalMessage";
    
    /**
     * @constant
     */
    UNBLOCK_TERMINAL = "unblockTerminal";
    
    /**
     * @constant
     */
    ALL_TABS_READY = "allTabsReady";
}

/**
 * @ignore 
 * Class representing publisheable events to EGM 
 * */
class CallableMethods {
    
    /** 
     * @constant
     */
    CONTENT_READY = "content_ready"
    
    /** 
     * @constant
     */
    PLAY_STARTED = "play_started"
    
    /** 
     * @constant
     */
    PLAY_ENDED = "play_ended"
    
    /** 
     * @constant
     */
    CHANGE_CONTENT = "change_content"
    
    /** 
     * @constant
     */
    REQUEST_CASHOUT = "request_cashout"
    
    /** 
     * @constant
     */
    CLOSE_CONTENT = "close_content"
    
    /** 
     * @constant
     */
    ENABLE_CONTENT = "enable_content"

    
    /** 
     * @constant
     */
    BINGO_CASHIN = "bingo_cashin"
    
    /** 
     * @constant
     */
    FATAL_ERROR = "fatal_error"
    
    /** 
     * @constant
     */
    REQUEST_ACTION = "request_action"
    
    /** 
     * @constant
     */
    SEND_NOTIFICATION = "notify"

    /** 
     * @constant
     */
    GET_CONTENT = "get_content"
    
    /** 
     * @constant
     */
    GET_CONFIG = "get_config"
    
    /** 
     * @constant
     */
    GET_BILLER_TRANSACTION = "get_biller_transaction"
        
    /** 
     * @constant
     */
    IS_CONTENT_ENABLED = "is_content_enabled"


    
}


/** Class representing a EGM Backend lib */
class Backend {
    
    EVENTS = new EventListerners()

    

    /**
     * @const - Events to subscribe for content
     * @type {SubscribableEvents}
     */
    SUBSCRIBE_EVENTS = new SubscribableEvents();
    

    /**
     * @const - Callable methods by content
     * @type {CallableMethods}
     */
    LOCAL_API_METHODS = new CallableMethods();  


    /**
     * Create egmLib as Singleton.
     * 
     */
    constructor() {
        if(!instance) {
            instance = this;
            this.emitter = new Emittery();
            this._registerEGMToContentLegacyMethods();
            
            if (window.ReactNativeWebView) {
                this._apkMethodsHandler();
            } else {
                this._localApiMethodsHandler();
            }
            
            this.subscribeEvent(this.SUBSCRIBE_EVENTS.UPDATE_BALANCE, (data)=> this.emitter.emit(this.EVENTS.BALANCE_UPDATED, data));

            this.subscribeEvent(this.SUBSCRIBE_EVENTS.BLOCK_TERMINAL_MESSAGE, (data)=> this.emitter.emit(this.EVENTS.BLOCK_UI, data));
            this.subscribeEvent(this.SUBSCRIBE_EVENTS.BLOCK_TERMINAL, (data)=> this.emitter.emit(this.EVENTS.BLOCK_UI, data));
            
            this.subscribeEvent(this.SUBSCRIBE_EVENTS.UNBLOCK_TERMINAL, (data)=> this.emitter.emit(this.EVENTS.UNBLOCK_UI, data));
            this.subscribeEvent(this.SUBSCRIBE_EVENTS.BLOCK_CONTENT, (data)=> this.emitter.emit(this.EVENTS.BLOCK_UI, data));
            this.subscribeEvent(this.SUBSCRIBE_EVENTS.UNBLOCK_CONTENT, (data)=> this.emitter.emit(this.EVENTS.UNBLOCK_UI, data));

            this.subscribeEvent(this.LOCAL_API_METHODS.CONTENT_READY, this.callApiMethod.bind(this, this.SUBSCRIBE_EVENTS.ALL_TABS_READY));

            this.subscribeEvent(this.SUBSCRIBE_EVENTS.DEVICE_EVENT, (data)=> this.emitter.emit(this.EVENTS.ON_DEVICE_EVENT, data));

            
        }
        return instance;
    }

    _postReactNative(messageJson) {
        try {
            window.ReactNativeWebView.postMessage(JSON.stringify(messageJson));
        } catch (error) {
            console.warn("Error occurred while posting message:", error);
        }
    }

    /**
     * Request a activity session
     * @return {string} The session id.
     */
    requestActivitySession() {
        return "";
    }

    /**
     * Close current activity session
     */
    closeCurrentActivitySession() {
        //TBI
    }

    /**
     * Send object message to specific tab by id
     * @param {string} tabId - The tab identifier.
     * @param {object} message - The object message, only filled with primitives.
     */
    sendMessageToTab(tabId, message) {
        //TBI
    }

    /**
     * Send object message to all tabs
     * @param {object} message - The object message, only filled with primitives.
     */
    sendMessageToAllTabs(message) {
        //TBI
    }

    /**
     * Get all tabs id available
     * @return {Array<string>} An array of tab ids.
     */
    getAllTabsAvailables() {
        return [this.getCurrentTabId()];
    }

    /**
     * Get current tab id.
     * @return {string} Current tab id
     */
    getCurrentTabId() {
        //TBI
        return "1";
    }


    /**
     * Send custom state for content
     * @param {string} state - The tab identifier.
     */
    setContentState(state) {
        return this.requestAction("setContentState", {"state": state});
    }

    /**
     * Get custom state for content
     * @return {Promise<string>} A promise with state of the content
     */
    getCurrentContentState() {
        return this.requestAction("getContentState").then((value)=> {
            return value["response"];
        });
    }

    /**
     * Call it when all of your content stuff is loaded
     */
    setContentReady() {
        this.callApiMethod(this.LOCAL_API_METHODS.CONTENT_READY);
    }
    

    /**
     * Get states of terminal
     * @return {Promise<Array<string>>} A promise
     * */
    getTerminalStates() {
        return this.requestAction("getTerminalStates").then((value)=> {
                return value["response"];
            });

    }

    /**
     * Get list of available actions
     * @return {Promise<Array<string>>} A promise
     * */
    getAvailableActions() {
        return this.requestAction("getAvailableActions").then((value)=> {
            return value["response"];
        });
    }


    /**
     * requestAction call in server
     * @param {string} actionId - action id name.
     * @param {string} params - action params.
     * @return {Promise<object>} A promise with action response
     */

    requestAction(actionId, params={}) {
        //TBI
        return this.callApiMethod("request_action", {"action_id": actionId, "params": params});
    }

    /**
     * Get terminal config 
     * @return {Promise<object>} A promise with action response
     * @fullfill {}
     */
    getTerminalConfig() {
        return this.callApiMethod(this.LOCAL_API_METHODS.GET_CONFIG, {});
    }

    /**
     * Request to change content
     * @param {string} contentId - action id name.
     * @return {Promise} A promise with action response
     * 
     */

    requestChangeContent(contentId) {
        return this.callApiMethod(this.LOCAL_API_METHODS.CHANGE_CONTENT, {'content_id': contentId});
    }

    /**
     * @ignore
     * Subscribe to Event 
     * @param {string} PublicEvents - event key to subscribe
     * @param  {function} callback - callback function
     * @return {function} Unsubscribe function callback
     */
    listenEvent(event, callback) {
        return this.subscribe(event, callback);
    }


    //Core

    /**
     * @ignore
     * Call api method by methodId
     * @param {string} methodId - the methodId to call.
     * @param  {object} params - The object params, only filled with primitives.
     * @return {Promise} Promise for this async action
     */
    callApiMethod(methodId, params={}) {
        let deferredPromise = new DeferredPromise();
        this.emitter.emit(methodId, {params, deferredPromise});
        return deferredPromise.promise;
    }

    /**
     * @ignore
     * @param {string} methodId 
     * @param {*} params 
     * @returns {Promise}
     */
    _legacyGlobalFunctionsHandler(methodId, params={}) {
        let deferredPromise = new DeferredPromise();
        this.emitter.emit(methodId, params);
        return deferredPromise.promise;
    }

    /**
     * @ignore
     * Subscribe to Event 
     * @param {string} event - event key to subscribe
     * @param  {function} callback - callback function
     * @return {function} Unsubscribe function callback
     */
    subscribeEvent(event, callback) {
        return this.emitter.on(event, callback);
    }

    /**
     * @ignore
     * Unsubscribe event
     * @param {string} event - event key to unsubscribe
     * @param  {function} callback - callback function
     * @return {Promise} Promise for this action
     */
    unsubscribeEvent(event, callback) {
        return this.emitter.off(event, callback);
    }



    _registerEGMToContentLegacyMethods() {
        //EGM to Content legacy support for root functions
        let methods = [
            this.SUBSCRIBE_EVENTS.UNBLOCK_CONTENT,
            this.SUBSCRIBE_EVENTS.BLOCK_CONTENT,
            this.SUBSCRIBE_EVENTS.UPDATE_BALANCE,
            this.SUBSCRIBE_EVENTS.BLOCK_TERMINAL,
            this.SUBSCRIBE_EVENTS.BLOCK_TERMINAL_AND_CASHOUT,
            this.SUBSCRIBE_EVENTS.BLOCK_TERMINAL_MESSAGE,
            this.SUBSCRIBE_EVENTS.UNBLOCK_TERMINAL,
            this.SUBSCRIBE_EVENTS.DEVICE_EVENT,
            this.SUBSCRIBE_EVENTS.ENABLE_KEYPAD_FUNCTIONALITY,
          
        ]
        for (let key of methods) {
            window[key] = this._legacyGlobalFunctionsHandler.bind(this, key);
            if (window.parent) {
                window.parent[key] = this._legacyGlobalFunctionsHandler.bind(this, key);
            }
        }
    }
    _getMappedApkMethods() {
        let configContentToEgm = {};
        configContentToEgm[this.LOCAL_API_METHODS.GET_BILLER_TRANSACTION] = "get_biller_transaction";
        configContentToEgm[this.LOCAL_API_METHODS.GET_CONTENT]= {"method": "get_games"};
        configContentToEgm[this.LOCAL_API_METHODS.GET_CONFIG]= {"method": "get_games"};
        configContentToEgm[this.LOCAL_API_METHODS.IS_CONTENT_ENABLED]= {"method": "is_content_enabled"};

        //methods without return values
        configContentToEgm[this.LOCAL_API_METHODS.CONTENT_READY]= {"method": "terminal_ready"};
        configContentToEgm[this.LOCAL_API_METHODS.PLAY_STARTED]= {"method": "play_started"};
        configContentToEgm[this.LOCAL_API_METHODS.PLAY_ENDED]= {"method": "play_ended"};
        configContentToEgm[this.LOCAL_API_METHODS.CHANGE_CONTENT]= {"method": "change_game", "mapArgs": {"content_id": "game_id"}}; //params: { game_id: str}
        configContentToEgm[this.LOCAL_API_METHODS.REQUEST_CASHOUT]= "request_cashout";
        configContentToEgm[this.LOCAL_API_METHODS.CLOSE_CONTENT]= {"method": "close_game"};
        configContentToEgm[this.LOCAL_API_METHODS.ENABLE_CONTENT]= {"method": "enable_content"};
        configContentToEgm[this.LOCAL_API_METHODS.BINGO_CASHIN]= {"method": "bingo_cashin"}; //params { amount, cashin, play_id }
        configContentToEgm[this.LOCAL_API_METHODS.FATAL_ERROR]= {"method": "fatal_error"}; // params: {code: str, error: str}
        configContentToEgm[this.LOCAL_API_METHODS.REQUEST_ACTION]= {"method": "request_action"};  //params { action_id }
        configContentToEgm[this.LOCAL_API_METHODS.SEND_NOTIFICATION]= {"method": "notify"}; //params { notify_type }
        return configContentToEgm;
    }
    
    _getMappedMethods() {
        let configContentToEgm = {};
        configContentToEgm[this.LOCAL_API_METHODS.GET_BILLER_TRANSACTION] = {"method": "get_biller_transaction"};
        configContentToEgm[this.LOCAL_API_METHODS.GET_CONTENT]= {"method": "get_games"};
        configContentToEgm[this.LOCAL_API_METHODS.GET_CONFIG]= {"method": "config"};
        configContentToEgm[this.LOCAL_API_METHODS.IS_CONTENT_ENABLED]= {"method": "is_content_enabled"};

        //methods without return values
        configContentToEgm[this.LOCAL_API_METHODS.CONTENT_READY]= {"method": "game_ready"};
        configContentToEgm[this.LOCAL_API_METHODS.PLAY_STARTED]= {"method": "play_started"};
        configContentToEgm[this.LOCAL_API_METHODS.PLAY_ENDED]= {"method": "play_ended"};
        configContentToEgm[this.LOCAL_API_METHODS.CHANGE_CONTENT]= {"method": "change_game", "mapArgs": {"content_id": "game_id"}}; //params: { game_id: str}
        configContentToEgm[this.LOCAL_API_METHODS.REQUEST_CASHOUT]= "request_cashout";
        configContentToEgm[this.LOCAL_API_METHODS.CLOSE_CONTENT]= {"method": "close_game"};
        configContentToEgm[this.LOCAL_API_METHODS.ENABLE_CONTENT]= {"method": "enable_content"};
        configContentToEgm[this.LOCAL_API_METHODS.BINGO_CASHIN]= {"method": "bingo_cashin"}; //params { amount, cashin, play_id }
        configContentToEgm[this.LOCAL_API_METHODS.FATAL_ERROR]= {"method": "fatal_error"}; // params: {code: str, error: str}
        configContentToEgm[this.LOCAL_API_METHODS.REQUEST_ACTION]= {"method": "request_action", "api_method": "POST"};  //params { action_id }
        configContentToEgm[this.LOCAL_API_METHODS.SEND_NOTIFICATION]= {"method": "notify"}; //params { notify_type }
        return configContentToEgm;
    }

    
    _apkMethodsHandler() {
        //CONTENT TO EGM
        let configContentToEgm = this._getMappedApkMethods();

        for(let key in configContentToEgm) {
            let config = configContentToEgm[key];
            
            let method = typeof config == "string" ? config : config.method;
            let mapArgs = typeof config == "string" ? null : config.mapArgs;

            const subscriptionCallback = (data) => {
                let postedParams = data.params;
                let newParams = {};
                if (mapArgs) {
                    Object.keys(mapArgs).map(function(key) {
                        newParams[mapArgs[key]] = postedParams[key];
                        });
                } else {
                    newParams = postedParams;
                }
                //generte timestamp id for call
                let timestamp = new Date().getTime();
                let methodId = `${method}_${timestamp}`;

                //ADD EVENT LISTERNER POSTMESSAGE RESPONSE AND REMOVE WHEN RECEIVED
                window.addEventListener("message", (event) => {
                    //check method id
                    if (event.data.methodId == methodId) {
                        if (data.deferredPromise) {
                            data.deferredPromise.resolve(event.data.response);
                        }
                        //remove event listener
                        window.removeEventListener("message", arguments.callee);
                    }
                }, false);
                
                // POST MESSAGE TO React native webview

                this._postReactNative({method: method, params: newParams, methodId: methodId});
                 
            };
            this.subscribeEvent(key, subscriptionCallback);
        }

    }


    _localApiMethodsHandler() {
        //CONTENT TO EGM
        let urlParams = new URLSearchParams(window.location.search);
        let baseUrl = urlParams.get("egm_local_api_url") || "http://localhost:5000/";
        let configContentToEgm = this._getMappedMethods();

        for(let key in configContentToEgm) {
            let config = configContentToEgm[key];
            
            let method = typeof config == "string" ? config : config.method;
            let mapArgs = typeof config == "string" ? null : config.mapArgs;
            let request_method = typeof config == "string" ? "GET" : config.api_method || "GET";  //default
            let urlCall = baseUrl + method; 

            const subscriptionCallback = (data) => {
                let postedParams = data.params;
                let newParams = {};
                if (mapArgs) {
                    Object.keys(mapArgs).map(function(key) {
                        newParams[mapArgs[key]] = postedParams[key];
                      });
                } else {
                    newParams = postedParams;
                }

                if (data.deferredPromise) {
                    //default GET
                    let request_config = { url: urlCall, method: request_method, params: newParams};
                    if ((request_method == "POST")) {
                        request_config.data = newParams;
                        request_config.params = {};
                        request_config.headers = { 'Content-Type': 'application/json' };
                    }

                    axios.request(request_config)
                            .then((response)=> data.deferredPromise.resolve(response.data))
                            .catch((error) => {
                                data.deferredPromise.reject(error);
                                console.warn("Error occurred during call to egm client server:", error);
                            });
                } else {
                    axios.get(urlCall, {params: newParams}).catch((error) => {
                        console.warn("Error occurred during call to egm client server:", error);
                    });
                }
            };
            this.subscribeEvent(key, subscriptionCallback);
        }

    }
}


export default Backend;